import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=27c97b87&scoped=true&"
import script from "./AccountInfo.vue?vue&type=script&lang=js&"
export * from "./AccountInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccountInfo.vue?vue&type=style&index=0&id=27c97b87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c97b87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27c97b87')) {
      api.createRecord('27c97b87', component.options)
    } else {
      api.reload('27c97b87', component.options)
    }
    module.hot.accept("./AccountInfo.vue?vue&type=template&id=27c97b87&scoped=true&", function () {
      api.rerender('27c97b87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PersonalCenter/AccountInfo/AccountInfo.vue"
export default component.exports